import {
  store,
  incNumberOfOrders,
  updateCategory,
  deleteCategory,
  updateSystemSettings,
  addKitchenTable,
  editKitchenTable,
  removeKitchenTable,
  addCombo,
  updateCombo,
  deleteCombo,
  updateFoods,
  createCategory,
  deleteFoods,
  addFoods,
  updateCustomerPrintTemplate,
  removeFoodsFromCategoryGroup,
  addFoodCategoryGroup,
  deleteFoodCategoryGroup,
  updateFoodsInCategoryGroup,
  addFoodToCategoryGroup,
  updateFoodSpecifications,
  addFoodSpecifications,
  addFoodTaxes,
  deleteFoodSpecifications,
  updateFoodTaxes,
  deleteFoodTaxes,
  updateRecommendedFoods,
  deleteRecommendedFoods,
  addRecommendedFoods,
  clearShift
} from "@redux"
import {
  haveAuth,
  userLogout,
  ipcApi,
  refactorFoods,
  printOrder,
  isDeviceCloudPrinter,
  isOrderForThisUser,
  ObjectValues,
  isInPosDevice,
  createPosPaymentRequest,
  isInKioskMode,
  clearSiteData
} from "utils"
import { sendPosTerminalAcknowledge, sendPosTerminalResult } from "services"
import { toast } from "react-toastify"

let isPlayingAudio = false

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

const playNotificationSound = async () => {
  if (isPlayingAudio) return

  const audio = new Audio("/assets/sounds/ding_sms.mp3")

  audio.play()

  isPlayingAudio = true

  const audioDurationMs = 1000

  // wait until finish do not play two sound at a time
  await delay(audioDurationMs)

  isPlayingAudio = false
}

const sendNotificationToMainProcces = () => {
  //for webview
  if (isInPosDevice()) {
    ipcApi({ type: "playSoundNotification" })

    return
  }

  playNotificationSound()
}

const thermalPrintRequest = async (
  order,
  skipKitchenReceipt,
  isOnlinePayment = false
) => {

  const canThisDevicePrint =
    isDeviceCloudPrinter() &&
    haveAuth(["printerAccess"])

  if (!canThisDevicePrint) return

  const printOrderItems =
    order.orderStatus === "paid"
      ?
      isOnlinePayment &&
      !skipKitchenReceipt
      :
      !skipKitchenReceipt

  const skipOrderItems = !printOrderItems

  await printOrder(
    order,
    skipKitchenReceipt,
    skipOrderItems
  )
}

const printCustomerReceiptToPos = async (value) => {
  if (!isInPosDevice()) return

  if (!value.sendPrintCustomerReceiptToPos) return

  const deviceName = window.posName || "sadad"

  if (deviceName !== value.posTerminalName) return

  const skipKitchenReceipt = false

  const skipOrderItems = false

  await printOrder(
    value.order,
    skipKitchenReceipt,
    skipOrderItems
  )
}

const orderCreated = value => {
  const { order } = value

  if (!isOrderForThisUser(order)) return

  printCustomerReceiptToPos(value)

  store.dispatch(
    incNumberOfOrders(order.orderStatus, 1)
  )

  const isNotConfirmed =
    order.orderStatus === "notConfirmed"

  if (isNotConfirmed) {
    return sendNotificationToMainProcces()
  }

  const isIncomplete =
    !order.isCod &&
    order.accountRole === "user" &&
    order.orderStatus === "pending"

  if (isIncomplete) return

  const showNotification =
    !order.isPrinted &&
    order.isCod &&
    order.accountRole === "user"

  showNotification &&
    sendNotificationToMainProcces()

  if (order.isPrinted) return

  const skipKitchenReceipt = false

  thermalPrintRequest(order, skipKitchenReceipt)
}

const orderPaid = value => {
  const { order: paidOrder } = value

  if (!paidOrder.isViewed) {
    store.dispatch(
      incNumberOfOrders("pending", -1)
    )

    store.dispatch(
      incNumberOfOrders("paid", 1)
    )
  }

  printCustomerReceiptToPos(value)

  const isOnlinePayment =
    !paidOrder.isCod &&
    paidOrder.accountRole === "user"

  const showNotification =
    paidOrder.isPaymentLink ||
    isOnlinePayment

  showNotification &&
    sendNotificationToMainProcces()

  const printable =
    paidOrder.isPaymentLink ||
    isOnlinePayment

  if (!printable) return

  const skipKitchenReceipt = paidOrder.isCod

  thermalPrintRequest(
    paidOrder,
    skipKitchenReceipt,
    isOnlinePayment
  )
}

const orderUpdated = value => {
  if (!value.order) return

  if (!isOrderForThisUser(value.order)) return

  if (value.event === "OrderPaid") {
    return orderPaid(value)
  }

  const isNotConfirmedCustomerOrder =
    value.event === "OrderUpdated" &&
    value.order.orderStatus === "notConfirmed" &&
    value.order.accountRole === "user" &&
    !value.order.isViewed

  if (isNotConfirmedCustomerOrder) {
    sendNotificationToMainProcces()
  }
}

const orderConfirmed = value => {
  const { order } = value

  if (!isOrderForThisUser(order)) return

  if (!order.isViewed) {
    store.dispatch(
      incNumberOfOrders("notConfirmed", -1)
    )

    store.dispatch(
      incNumberOfOrders("pending", 1)
    )
  }

  sendNotificationToMainProcces()

  const skipKitchenReceipt = false

  thermalPrintRequest(
    order,
    skipKitchenReceipt
  )
}

const taxCreated = (newTax) => {
  store.dispatch(
    addFoodTaxes([newTax])
  )
}

const taxUpdated = (updatedTax) => {
  store.dispatch(
    updateFoodTaxes([updatedTax])
  )
}

const taxDeleted = (deletedTax) => {
  const foodsMap = store.getState().foods

  if (foodsMap === null) return

  const foods = ObjectValues(foodsMap)

  const foodsWithNewTaxItems = []

  foods.forEach(food => {
    const isFoodTaxItemUpdated =
      food.taxItemIds.some(taxItemId =>
        taxItemId === deletedTax._id
      )

    if (!isFoodTaxItemUpdated) return

    const updatedTaxes =
      food.taxItemIds.filter(taxItemId =>
        taxItemId !== deletedTax._id
      )

    foodsWithNewTaxItems.push({
      ...food,
      taxItems: updatedTaxes
    })
  })

  store.dispatch(
    updateFoods(
      foodsWithNewTaxItems
    )
  )

  store.dispatch(
    deleteFoodTaxes([deletedTax._id])
  )
}

const foodSpecificationUpdated = (value) => {
  const cashierBranchId =
    store.getState().userAccountInfo.branchId

  if (value.branchId !== cashierBranchId) return

  const foodsMap = store.getState().foods

  if (foodsMap === null) return

  const {
    specification,
    addedToFoodIds,
    removedFromFoodIds
  } = value

  const foodsWithNewSpecifications = []

  addedToFoodIds.forEach(addedToFoodId => {
    const food = foodsMap[addedToFoodId]

    if (!food) return

    foodsWithNewSpecifications.push({
      ...food,
      specificationIds: [...food.specificationIds, specification._id]
    })
  })

  removedFromFoodIds.forEach(removedFromFoodId => {
    const food = foodsMap[removedFromFoodId]

    if (!food) return

    foodsWithNewSpecifications.push({
      ...food,
      specificationIds:
        food.specificationIds.filter(sId =>
          sId !== specification._id
        )
    })
  })

  store.dispatch(
    updateFoods(
      foodsWithNewSpecifications
    )
  )
}

const specificationCreated = (value) => {
  store.dispatch(
    addFoodSpecifications(
      [value]
    )
  )
}

const specificationUpdated = (editedSpecification) => {
  store.dispatch(
    updateFoodSpecifications(
      [editedSpecification]
    )
  )
}

const specificationDeleted = (deletedSpecification) => {
  const foodsMap = store.getState().foods

  if (foodsMap === null) return

  const foods = ObjectValues(foodsMap)

  const foodsWithNewSpecifications = []

  foods.forEach(food => {
    const isFoodSpecificationUpdated =
      food.specificationIds.some(specificationId =>
        specificationId === deletedSpecification._id
      )

    if (!isFoodSpecificationUpdated) return

    const updatedSpecificationIds =
      food.specificationIds.filter(specificationId =>
        specificationId !== deletedSpecification._id
      )

    foodsWithNewSpecifications.push({
      ...food,
      specificationIds: updatedSpecificationIds
    })
  })

  store.dispatch(
    updateFoods(
      foodsWithNewSpecifications
    )
  )

  store.dispatch(
    deleteFoodSpecifications(
      [deletedSpecification._id]
    )
  )
}

const categoryCreated = value => {
  store.dispatch(
    createCategory(value)
  )

  store.dispatch(
    addFoodCategoryGroup(value)
  )
}

const categoryUpdated = value => {
  const { category } = value

  store.dispatch(
    updateCategory(category)
  )
}

const categoryDeleted = value => {
  store.dispatch(
    deleteCategory(value._id)
  )

  store.dispatch(
    deleteFoodCategoryGroup(value)
  )
}

const settingUpdated = value => {
  store.dispatch(
    updateSystemSettings(value)
  )
}

const tableCreated = (value) => {
  const { userAccountInfo } = store.getState()

  if (value.branchId !== userAccountInfo.branchId) return

  store.dispatch(
    addKitchenTable(value)
  )
}

const tableUpdated = (value) => {
  store.dispatch(
    editKitchenTable(value._id, value)
  )
}

const tableDeleted = (value) => {
  store.dispatch(
    removeKitchenTable(value._id)
  )
}

const comboCreate = (value) => {
  const { userAccountInfo } = store.getState()

  const comboBranchId =
    value.comboSets[0].branchId

  if (comboBranchId !== userAccountInfo.branchId) return

  store.dispatch(
    addCombo(value)
  )
}

const comboUpdated = (value) => {
  store.dispatch(
    updateCombo(value)
  )
}

const comboDeleted = (value) => {
  store.dispatch(
    deleteCombo(value._id)
  )
}

const accountUpdated = (value) => {
  const accountId =
    store.getState().userAccountInfo._id

  if (accountId !== value._id) return

  userLogout()

  window.location.href = "/"
}

const accessUpdated = (value) => {
  const accesses =
    store.getState().userAccountInfo.accesses

  const accessChanged =
    accesses.accessIds.some(accessId =>
      accessId === value._id
    )

  if (!accessChanged) return

  userLogout()

  window.location.href = "/"
}

const foodDeleted = food => {
  store.dispatch(
    deleteFoods([food])
  )

  store.dispatch(
    removeFoodsFromCategoryGroup([food])
  )
}

const foodCreated = async food => {
  const branchId =
    store.getState().userAccountInfo.branchId

  const [refactoredFood] =
    refactorFoods([food], branchId)

  const isFoodForThisBranch =
    !!refactoredFood

  if (!isFoodForThisBranch) return

  store.dispatch(
    addFoods([refactoredFood])
  )

  store.dispatch(
    addFoodToCategoryGroup(refactoredFood)
  )
}

const foodUpdated = async food => {
  const branchId =
    store.getState().userAccountInfo.branchId

  const refactoredFood =
    refactorFoods([food], branchId)

  const isFoodBranchChanged =
    refactoredFood.length === 0

  if (isFoodBranchChanged) {
    store.dispatch(
      deleteFoods([food])
    )

    store.dispatch(
      removeFoodsFromCategoryGroup([food])
    )

    return
  }

  store.dispatch(
    updateFoodsInCategoryGroup(refactoredFood)
  )

  store.dispatch(
    updateFoods(refactoredFood)
  )
}

const customerPrintTemplateUpdated = (value) => {
  const { cashierBranches } =
    store.getState().userAccountInfo

  const isTemplateInThisBranch =
    cashierBranches.some(cb => cb._id === value.branchId)

  if (!isTemplateInThisBranch) return

  const components =
    JSON.parse(value.componentsJson)

  store.dispatch(
    updateCustomerPrintTemplate(components)
  )
}

const posTerminalPaymentRequest = async (value) => {
  if (!isInPosDevice()) return

  const deviceName = window.posName || "sadad"

  if (deviceName !== value.terminalName) return

  try {
    await sendPosTerminalAcknowledge({
      terminalName: value.terminalName,
      requestId: value.requestId
    })

    const result =
      await createPosPaymentRequest(value.amount)

    await sendPosTerminalResult({
      success: result,
      terminalName: value.terminalName,
      amount: value.amount,
      requestId: value.requestId
    })
  } catch (err) {
    console.log(err)
  }
}

const shiftClosed = (value) => {
  const { shiftCashier, userAccountInfo } = store.getState()

  if (!shiftCashier[userAccountInfo._id]) return

  const shiftId =
    shiftCashier[userAccountInfo._id]._id

  if (shiftId !== value.shiftId) return

  store.dispatch(clearShift())

  clearSiteData()

  window.history.pushState({}, "", isInKioskMode() ? "/kiosk-languages" : "/foods")

  toast.error("شیفت از طرف ادمین بسته شد", { autoClose: false })
}

const recommendedFoodsCreated = async (value) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  if (value.branchId !== branchId) return

  store.dispatch(
    addRecommendedFoods(value)
  )
}

const recommendedFoodsUpdated = async (value) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  if (value.branchId !== branchId) return

  store.dispatch(
    updateRecommendedFoods(value)
  )
}

const recommendedFoodsDeleted = async (value) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  if (value.branchId !== branchId) return

  store.dispatch(
    deleteRecommendedFoods()
  )
}

const listenToIncomingEvents = jsonMessage => {
  const message = JSON.parse(jsonMessage)

  switch (message.key) {
    case "orderCreated":
      orderCreated(message.value)
      break
    case "orderUpdated":
      orderUpdated(message.value)
      break
    case "orderConfirmed":
      orderConfirmed(message.value)
      break
    case "foodCreated":
      foodCreated(message.value)
      break
    case "foodUpdated":
      foodUpdated(message.value)
      break
    case "foodDeleted":
      foodDeleted(message.value)
      break
    case "foodSpecificationUpdated":
      foodSpecificationUpdated(message.value)
      break
    case "specificationCreated":
      specificationCreated(message.value)
      break
    case "specificationUpdated":
      specificationUpdated(message.value)
      break
    case "specificationDeleted":
      specificationDeleted(message.value)
      break
    case "couponCreated":
      comboCreate(message.value)
      break
    case "couponUpdated":
      comboUpdated(message.value)
      break
    case "couponDeleted":
      comboDeleted(message.value)
      break
    case "categoryCreated":
      categoryCreated(message.value)
      break
    case "categoryUpdated":
      categoryUpdated(message.value)
      break
    case "categoryDeleted":
      categoryDeleted(message.value)
      break
    case "settingUpdated":
      settingUpdated(message.value)
      break
    case "tableCreated":
      tableCreated(message.value)
      break
    case "tableUpdated":
      tableUpdated(message.value)
      break
    case "tableDeleted":
      tableDeleted(message.value)
      break
    case "taxCreated":
      taxCreated(message.value)
      break
    case "taxUpdated":
      taxUpdated(message.value)
      break
    case "taxDeleted":
      taxDeleted(message.value)
      break
    case "accountUpdated":
      accountUpdated(message.value)
      break
    case "accessUpdated":
      accessUpdated(message.value)
      break
    case "customerPrintTemplateUpdated":
      customerPrintTemplateUpdated(message.value)
      break
    case "posTerminalPaymentRequest":
      posTerminalPaymentRequest(message.value)
      break
    case "recommendedFoodsCreated":
      recommendedFoodsCreated(message.value)
      break
    case "recommendedFoodsUpdated":
      recommendedFoodsUpdated(message.value)
      break
    case "recommendedFoodsDeleted":
      recommendedFoodsDeleted(message.value)
      break
    case "shiftClosed":
      shiftClosed(message.value)
      break

    default: return
  }
}

export default listenToIncomingEvents
